import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Label } from '@atlas/ui';

const DateRangePicker = ({ disabled = false, calendarDateRange, setCalendarDateRange }) => {
  const { from: startDate, to: endDate } = calendarDateRange;

  const todayDate = useMemo(() => {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();

    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }

    return `${yyyy}-${mm}-${dd}`;
  }, []);

  const onStartDatesChange = ({ target: { value } }) => {
    const startDate = dayjs(value);
    const startDateToSet = startDate.isBefore(todayDate) ? startDate : dayjs();
    const endDateToSet = endDate && startDateToSet.isBefore(endDate) ? endDate : dayjs();
    setCalendarDateRange({
      from: startDateToSet,
      to: endDateToSet,
    });
  };

  const onEndDatesChange = ({ target: { value } }) => {
    const endDate = dayjs(value);
    const endDateToSet = endDate.isBefore(todayDate) ? endDate : dayjs();
    const startDateToSet = startDate && endDateToSet.isAfter(startDate) ? startDate : endDateToSet;
    setCalendarDateRange({
      from: startDateToSet,
      to: endDateToSet,
    });
  };

  const startDateValue = useMemo(() => startDate.format('YYYY-MM-DD'), [startDate]);
  const endDateValue = useMemo(() => endDate.format('YYYY-MM-DD'), [endDate]);

  return (
    <div className="chips-list">
      <input
        type="date"
        value={startDateValue}
        className="input-as-chips-item"
        data-date-format="DD/MM/YYYY"
        disabled={disabled}
        onChange={onStartDatesChange}
        max={todayDate}
      />
      <Label className="sub-title-500-text" message="to" />
      <input
        type="date"
        value={endDateValue}
        className="input-as-chips-item"
        data-date-format="DD/MM/YYYY"
        disabled={disabled}
        onChange={onEndDatesChange}
        max={todayDate}
      />
    </div>
  );
};

DateRangePicker.propTypes = {
  disabled: PropTypes.bool,
  calendarDateRange: PropTypes.object.isRequired,
  setCalendarDateRange: PropTypes.func.isRequired,
};

export default DateRangePicker;
